module.exports = __webpack_public_path__ + "img/image-culture-5.aeaae522.png";